import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { Stage3 } from 'src/app/models/department-reports.model';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ReportsService } from 'src/app/services/reports.service';
import { first } from 'rxjs';
import saveAs from 'file-saver';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import {shareReplay} from 'rxjs/operators';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
@Component({
  selector: 'app-stage3-report',
  templateUrl: './stage3-report.component.html',
  styleUrls: ['./stage3-report.component.scss']
})
export class Stage3ReportComponent implements OnInit {

  stage3: any[];
  totalApp:number;
  totalReceivedCoverageArea:number;
  totalApproveApp:number;
  totalApprovedCoverageArea:number;
  totalAppIncomplete:number;
  totalAppPending:number;
  totalAppRejected:number;
  totalIntimationStage1:number;
  pendingAtJe:number;
  pendingAtXen:number;
  pendingAtDmicada:number;
  pendingAtAdmin:number;
  phyDone:number;
  grandTotalApp:number;
  grandTotalReceivedCoverageArea:number;
  grandTotalApproveApp:number;
  grandTotalApprovedCoverageArea:number;
  grandTotalAppIncomplete:number;
  grandTotalAppPending:number;
  grandTotalAppRejected:number;
  grandTotalIntimationStage1:number;
  grandPendingAtJe:number;
  grandPendingAtXen:number;
  grandPendingAtDmicada:number;
  grandPendingAtAdmin:number;
  grandPhyDone:number;
  arrayIndex:number;
  tempStage3: any[];
  appVerificationItems: MenuItem[];
  appVerificationModel: Stage3[];
  filteredDataForExport: any = [];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  public filteredData: any = [];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  
  public userID: any;
  drilldownDetails:any;
  displayMaximizable_all:boolean;
  displayMaximizable_verified:boolean;
  displayMaximizable_incomplete:boolean;
  displayMaximizable_rejected:boolean;
  displayMaximizable_pending:boolean;
  value:any;
  displayMaximizable_dmicada:boolean;
  displayMaximizable_admin:boolean;
  routePath:any;
  subjectSub:any;
  selectedYear:any;
  public subscriptions: any = [];
  public loading: boolean = false;
  constructor(private reportsService:ReportsService
     ,private messageService:MessageService
     ,private dashboard: DashboardService
     ,private router: Router
     ,private activityRecordService: ActivityRecordService
     ,private loader: AppLoaderService
     ,private service: BaseService
     ,private cryptoJsService: CryptoJsService) { }

  ngOnInit(): void {
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;

    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
          let router=this.router.url
    // this.routePath=router.split('/')
        
      this.subscriptions.forEach(sub => sub.unsubscribe());
        this.selectedYear=res
        
        this.loadData(this.selectedYear)
      }
          
  );
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.appVerificationModel, "Stage3_report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.appVerificationModel, "Stage3_report");
        }
      },
    ];
  }
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
  }

  loadData(selectedYear:any){
     // this.loader.start();
     this.loading = true;
     let sub=this.reportsService.getStage3_Report(selectedYear)
        .pipe(first())
        .subscribe({
          next: (data) => {
             // this.loader.close();
             this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'Stage-3 Report', '', new Date(), 'Success');

            if (data?.length > 0) {
              this.stage3 = data;
              this.appVerificationModel = data;
              this.tempStage3=data;
              this.arrayIndex=0;
              this.calculateGrandTotal()
             
            }
            else{
              this.stage3 =[]
              this.appVerificationModel = []
              this.tempStage3=[]
              this.calculateGrandTotal()
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
            }
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;           
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
            this.activityRecordService.activityRecord(this.userID, 'Stage-3 Report', '', new Date(), err);

           

          }
        });
        this.subscriptions.push(sub);
  }

  exportExcel(modelData, filename) {
    
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "District" : d.district,
          "Total App Recieved" : d.Total_App_Recieved,
          "Recieved Coverage Area": d.recieved_Coverage_Area,
          "Total Approved Application": d.total_Approved_Application,
          "Approved Coverage Area": d.approved_Coverage_Area,
          "Total App Incomplete": d.total_App_Incomplete,
          "Total App Pending": d.total_App_Pending,
          "Total App Rejected": d.total_App_Rejected,
          "Pending At DMICADA": d.pending_At_DMICADA,
          "Pending At Admin": d.pending_At_Admin,
        }
      })
      
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {field: 'district', header: 'district'},
      {field: 'Total_App_Recieved', header: 'Total App Recieved'},
      { field: 'recieved_Coverage_Area', header: 'Recieved Coverage Area' },
      { field: 'total_Approved_Application', header: 'Total Approved Application' },
      {field: 'approved_Coverage_Area', header: 'Approved Coverage Area'},
      {field: 'total_App_Incomplete', header: 'Total App Incomplete'},
      {field: 'total_App_Pending', header: 'Total App Pending'},
      {field: 'total_App_Rejected', header: 'Total App Rejected'},,
      {field: 'pending_At_DMICADA', header: 'Pending At DMICADA'},
      {field: 'pending_At_Admin', header: 'Pending At Admin'},
     
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }
  tableDataFunction(event: any) {
    this.tempStage3=event.filteredValue
    //console.log(event);
    this.arrayIndex=0;
    // console.log(this.vendorWise);
    this.calculateTotalApp() ;
  }
  onPage(event:any) {
        this.arrayIndex=event.first;
        this.calculateTotalApp()
        //console.log(event);
      }
calculateTotalApp() {
        this.totalApp=0;
        this.totalReceivedCoverageArea=0;
        this.totalApproveApp=0;
        this.totalApprovedCoverageArea=0;
        this.totalAppIncomplete=0;
        this.totalAppPending=0;
        this.totalAppRejected=0;
        this.totalIntimationStage1=0;
        this.pendingAtJe=0;
        this.pendingAtXen=0;
        this.pendingAtDmicada=0;
        this.pendingAtAdmin=0;
        this.phyDone=0;
        
          for(let i=this.arrayIndex ;this.tempStage3.length>10?i<this.arrayIndex+10:i<this.tempStage3.length;i++) {
            this.totalApp +=this.tempStage3[i].Total_App_Recieved;
            this.totalReceivedCoverageArea +=this.tempStage3[i].recieved_Coverage_Area;
            this.totalApproveApp +=this.tempStage3[i].total_Approved_Application;
            this.totalApprovedCoverageArea += this.tempStage3[i].approved_Coverage_Area;
            this.totalAppIncomplete += this.tempStage3[i].total_App_Incomplete;
            this.totalAppPending += this.tempStage3[i].total_App_Pending;
            this.totalAppRejected += this.tempStage3[i].total_App_Rejected;
            this.pendingAtDmicada +=this.tempStage3[i].pending_At_DMICADA;
            this.pendingAtAdmin +=this.tempStage3[i].pending_At_Admin;
  
          }

        
              
    }
    calculateGrandTotal(){
      this.grandTotalApp=0;
      this.grandTotalReceivedCoverageArea=0;
      this.grandTotalApproveApp=0;
      this.grandTotalApprovedCoverageArea=0;
      this.grandTotalAppIncomplete=0;
      this.grandTotalAppPending=0;
      this.grandTotalAppRejected=0;
      this.grandPendingAtDmicada=0;
      this.grandPendingAtAdmin=0;
      for(let stage3Data of this.tempStage3) {
        this.grandTotalApp += stage3Data.Total_App_Recieved;
        this.grandTotalReceivedCoverageArea += stage3Data.recieved_Coverage_Area;
        this.grandTotalApproveApp += stage3Data.total_Approved_Application;
        this.grandTotalApprovedCoverageArea += stage3Data.approved_Coverage_Area;
        this.grandTotalAppIncomplete += stage3Data.total_App_Incomplete;
        this.grandTotalAppPending += stage3Data.total_App_Pending;
        this.grandTotalAppRejected += stage3Data.total_App_Rejected;
        this.grandPendingAtDmicada += stage3Data.pending_At_DMICADA;
        this.grandPendingAtAdmin += stage3Data.pending_At_Admin;
    }
    }
    showMaximizableDialog(district:any,status:any) {
      
      if(status=='All'){
        this.displayMaximizable_all=true
      }
      if(status=='Approved'){
        this.displayMaximizable_verified=true
      }
      if(status=='Incomplete'){
        this.displayMaximizable_incomplete=true
      }
      if(status=='Rejected'){
        this.displayMaximizable_rejected=true
      }
      if(status=='Pending'){
        this.displayMaximizable_pending=true
      }
      this.value=district
      this.drilldownDetails={
        district:district,
        status:status,
      }
      
  }
  showMaximizableDialog_pending(district:any,actionType:any) {
      
    
    if(actionType=='PendingDMICADAStage3'){
      this.displayMaximizable_dmicada=true
    }
    if(actionType=='PendingAdminStage3'){
      this.displayMaximizable_admin=true
    }
    this.value=district
    this.drilldownDetails={
      district:district,
      actionType:actionType,
      program:'Stage3'
    }
}

}
